import accountSettingsReducer from "@store/Store/Pages/AccountSettings/AccountSettingsReducer";
import cartReducer from "@store/Store/Pages/Cart/CartReducer";
import changeCustomerReducer from "@store/Store/Pages/ChangeCustomer/ChangeCustomerReducer";
import checkoutReviewAndSubmitReducer from "@store/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitReducer";
import checkoutShippingReducer from "@store/Store/Pages/CheckoutShipping/CheckoutShippingReducer";
import invoiceDetailsReducer from "@store/Store/Pages/InvoiceDetails/InvoiceDetailsReducer";
import invoiceHistoryReducer from "@store/Store/Pages/InvoiceHistory/InvoiceHistoryReducer";
import orderApprovalListReducer from "@store/Store/Pages/OrderApprovalList/OrderApprovalListReducer";
import orderHistoryReducer from "@store/Store/Pages/OrderHistory/OrderHistoryReducer";
import paymentHistoryReducer from "@store/Store/Pages/PaymentHistory/PaymentHistoryReducer";
import productDetailsPartsReducer from "@store/Store/Pages/ProductDetails/Parts/ProductDetailsPartsReducer";
import productDetailsReducer from "@store/Store/Pages/ProductDetails/ProductDetailsReducer";
import productDetailsWholegoodsReducer from "@store/Store/Pages/ProductDetails/Wholegoods/ProductDetailsWholegoodsReducer";
import productListReducer from "@store/Store/Pages/ProductList/ProductListReducer";
import quickOrderReducer from "@store/Store/Pages/QuickOrder/QuickOrderReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    productDetailsWholegoods: productDetailsWholegoodsReducer,
    productDetailsParts: productDetailsPartsReducer,
    productDetails: productDetailsReducer,
    orderHistory: orderHistoryReducer,
    invoiceHistory: invoiceHistoryReducer,
    invoiceDetails: invoiceDetailsReducer,
    accountSettings: accountSettingsReducer,
    paymentHistory: paymentHistoryReducer,
	orderApprovalList: orderApprovalListReducer,
	cart: cartReducer,
    productList: productListReducer,
    checkoutReviewAndSubmit: checkoutReviewAndSubmitReducer,
    quickOrder: quickOrderReducer,
    checkoutShipping: checkoutShippingReducer,
    changeCustomer: changeCustomerReducer,
};

export type PagesReducers = typeof pagesReducers;

const pagesReducer = combineReducers(pagesReducers as any);
export default pagesReducer;
